import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

const SuccessScreen = () => {
  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center p-4" data-testid="success-screen">
      <div className="max-w-lg w-full text-center">
        <div className="bg-[#141414] border border-[#D4AF37]/30 p-8 sm:p-12">
          <div className="w-20 h-20 mx-auto mb-6 bg-[#D4AF37] rounded-full flex items-center justify-center">
            <CheckCircle2 className="w-10 h-10 text-black" />
          </div>
          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-4">
            Thank You!
          </h2>
          <p className="text-[#A3A3A3] mb-8 leading-relaxed">
            Your property information has been submitted successfully. A member of our team will review your information and contact you shortly.
          </p>
          <Link 
            to="/"
            className="inline-block btn-gold px-8 py-4 text-lg font-bold"
            data-testid="return-home-button"
          >
            Return to Homepage
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SuccessScreen;
